(function () {
  'use strict';

  var DEBUG = window.SalepifyYmalOosSelectorConfig?.debug === true;
  var UNAVAILABLE_SUFFIX = ' - Unavailable';
  var OOS_BTN_CLASS = 'salepify-ymal-add-btn--oos';

  function log(label, data) {
    if (DEBUG) window.console?.log?.('[Salepify YMAL oos selector] ' + label, data);
  }

  function getVariantData(widgetEl, variantId) {
    var map = widgetEl && widgetEl.variantIdMapData;
    if (!map || typeof map.get !== 'function') return null;
    return map.get(variantId) || map.get(String(variantId)) || null;
  }

  function isOptionOOS(option, widgetEl) {
    if (option.disabled) return true;
    var variant = getVariantData(widgetEl, Number(option.value));
    return !!variant && variant.available === false;
  }

  function buildLabel(baseTitle, oos) {
    return oos ? baseTitle + UNAVAILABLE_SUFFIX : baseTitle;
  }

  function processOption(option, widgetEl) {
    if (option.dataset.sqProcessed === '1') return option.dataset.sqOos === '1';

    var wasDisabled = option.disabled;
    var oos = isOptionOOS(option, widgetEl);
    var baseTitle = (option.textContent || '').trim();
    option.dataset.sqBaseTitle = baseTitle;
    option.disabled = false;
    option.textContent = buildLabel(baseTitle, oos);
    option.dataset.sqOos = oos ? '1' : '0';
    option.dataset.sqProcessed = '1';
    log('option processed', { value: option.value, baseTitle: baseTitle, wasDisabled: wasDisabled, oos: oos, source: wasDisabled ? 'disabled-attr' : 'variantIdMapData' });
    return oos;
  }

  function updateAddBtn(item, isOOS) {
    var addBtn = item.querySelector('.salepify-ymal-add-btn');
    if (!addBtn) {
      log('add-btn not found for item', item.getAttribute('product-id'));
      return;
    }
    if (addBtn.classList.contains('salepify-ymal-add-btn--added') || addBtn.hasAttribute('data-permanent-disabled')) {
      log('add-btn already added/locked, skip', item.getAttribute('product-id'));
      return;
    }

    addBtn.classList.toggle(OOS_BTN_CLASS, isOOS);
    addBtn.setAttribute('aria-disabled', isOOS ? 'true' : 'false');
    if (addBtn.tagName === 'BUTTON') addBtn.disabled = isOOS;
    log('add-btn updated', { productId: item.getAttribute('product-id'), isOOS: isOOS });
  }

  function processItem(item) {
    try {
      var productId = item.getAttribute('product-id');
      var widgetEl = item.closest('salepify-ymal');
      var select = item.querySelector('.salepify-ymal-variant-selector select');
      if (!select) {
        log('no select for item (single variant)', productId);
        return; // sản phẩm 1 variant duy nhất -> variant đó luôn available
      }

      var options = select.querySelectorAll('option');
      log('processing item', { productId: productId, hasWidgetEl: !!widgetEl, optionCount: options.length });
      for (var i = 0; i < options.length; i++) processOption(options[i], widgetEl);

      var selectedOption = select.options[select.selectedIndex];
      updateAddBtn(item, !!selectedOption && selectedOption.dataset.sqOos === '1');
    } catch (error) {
      log('processItem failed', error);
    }
  }

  function processAll() {
    try {
      var items = document.querySelectorAll('.salepify-ymal-item');
      log('processAll', { itemCount: items.length });
      items.forEach(processItem);
    } catch (error) {
      log('processAll failed', error);
    }
  }

  var scheduled = false;
  function scheduleProcessAll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      processAll();
    });
  }

  function injectStyle() {
    if (document.getElementById('salepify-ymal-oos-style')) return;
    var style = document.createElement('style');
    style.id = 'salepify-ymal-oos-style';
    style.textContent = '.' + OOS_BTN_CLASS + '{opacity:.5;pointer-events:none;cursor:not-allowed;}';
    document.head.appendChild(style);
  }

  function start() {
    try {
      log('start', { readyState: document.readyState });
      injectStyle();
      processAll();

      // Re-check khi user đổi variant (đại diện cho cả 2 skin, không cần bind lại mỗi lần re-render)
      document.addEventListener('change', function (event) {
        var select = event.target.closest && event.target.closest('.salepify-ymal-variant-selector select');
        var item = select && select.closest('.salepify-ymal-item');
        if (item) {
          log('select change detected', item.getAttribute('product-id'));
          processItem(item);
        }
      }, true);

      // YMAL re-render toàn bộ widget khi resize / thêm item mới -> quét lại
      new MutationObserver(function (mutations) {
        log('mutation observed', mutations.length);
        scheduleProcessAll();
      }).observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      log('start failed', error);
    }
  }

  window.console?.log?.('[Salepify YMAL oos selector] script file loaded');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.SalepifyYmalOosSelector = { isOptionOOS: isOptionOOS, buildLabel: buildLabel };
})();
